import React from 'react';
import styles from './Footer.module.css';

const Footer = () => (
  <footer className={styles.footer}>&copy; 2018 by Lars Tijhuis. All rights reserved.</footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js